import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Cents__toDouble_impl_mg3etm3dxlfojyivr3o as Cents__toDouble_impl_mg3etm,
  Companion_instance1c40ds0jrup2e as Companion_instance,
  Cents1lsbs5l1tlgw as Cents,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import {
  text189ciz0cnr32o as text,
  h2ld0l0a2c9zpb as h2,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  validate3385a3bw04nw6 as validate,
  issueText2kcb4l1c5xll7 as issueText,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
  LabelSemantic_getInstance4iffxvo6ijig as LabelSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_dp28ag147e4p5cz as get_dp } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { DangerTextSemantic_getInstancetznd91yayzn7 as DangerTextSemantic_getInstance } from '../../theme/semantics.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { withStringBufferw9sv07w4j3wo as withStringBuffer } from './validation.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atEnd34105oxxaxc2o as get_atEnd,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  get_unpadded1ygmnwh0rw79t as get_unpadded,
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import { Align_End_getInstancer37lklmdzqms as Align_End_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth } from './view-utilities.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Form$stringField$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Form$emailField$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Form$dateField$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Form$priceInput$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Form$priceInput$lambda_0(it) {
  return Cents__toDouble_impl_mg3etm(it.inCents_1);
}
function Form$priceInput$lambda_1(it) {
  var tmp1_elvis_lhs = it == null ? null : Companion_instance.get_dollars_vjjqkb_k$(it);
  var tmp;
  var tmp_0 = tmp1_elvis_lhs;
  if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
    tmp = Companion_instance.get_cents_3bbzqx_k$(0);
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return new (Cents())(tmp);
}
function Form$formIssuesDialog$lambda(_this__u8e3s4) {
  text(_this__u8e3s4, 'Some required fields are missing. Please complete them to continue.');
  return Unit_instance;
}
function Form$formIssuesDialog$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
var FormClass;
function Form() {
  if (FormClass === VOID) {
    class $ {
      constructor(showValidation) {
        showValidation = showValidation === VOID ? Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false) : showValidation;
        this.showValidation_1 = showValidation;
      }
      get_showValidation_c0zzxd_k$() {
        return this.showValidation_1;
      }
      validate_fnk5sm_k$(_this__u8e3s4, field) {
        return validate(_this__u8e3s4, [field], ($this$validate) => $this$validate.invoke_r7m7el_k$(this.get_showValidation_c0zzxd_k$()));
      }
      stringField_7ac68e_k$(_this__u8e3s4, inputLabel, field, required, setup) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.Form.colWithIssueText' call
        var this_0 = this;
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
        ensureOutermostElement(element);
        _this__u8e3s4.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = themed(element, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element_0, LabelSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(false);
        element_1.set_gap_jwjroq_k$(get_dp(2));
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (TextView())(element_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element_1.willAddChild_hz2iwc_k$(element_2);
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_2);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_2));
        element_2.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          return inputLabel($this$invoke);
        });
        element_2.onStartup_vrxh3i_k$();
        element_1.addChild_2qpft2_k$(element_2);
        if (required) {
          text(themed(element_1, DangerTextSemantic_getInstance()), '*');
        }
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp$ret$18 = themed(element_0, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        var this_3 = this.validate_fnk5sm_k$(tmp$ret$18, field);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (TextInput())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_3.willAddChild_hz2iwc_k$(element_3);
        element_3.bind_gesskf_k$(element_3.content_1, field);
        setup(element_3);
        element_3.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_3);
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        var tmp_2 = get_issues(field);
        issueText(element, tmp_2, VOID, ($this$issueText) => $this$issueText.invoke_r7m7el_k$(this_0.get_showValidation_c0zzxd_k$()));
        element.onStartup_vrxh3i_k$();
        _this__u8e3s4.addChild_2qpft2_k$(element);
      }
      stringField$default_pwglgw_k$(_this__u8e3s4, inputLabel, field, required, setup, $super) {
        required = required === VOID ? false : required;
        var tmp;
        if (setup === VOID) {
          tmp = Form$stringField$lambda;
        } else {
          tmp = setup;
        }
        setup = tmp;
        var tmp_0;
        if ($super === VOID) {
          this.stringField_7ac68e_k$(_this__u8e3s4, inputLabel, field, required, setup);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $super.stringField_7ac68e_k$.call(this, _this__u8e3s4, inputLabel, field, required, setup);
        }
        return tmp_0;
      }
      emailField_ghhlxy_k$(_this__u8e3s4, inputLabel, field, required, setup) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.Form.colWithIssueText' call
        var this_0 = this;
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
        ensureOutermostElement(element);
        _this__u8e3s4.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = themed(element, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element_0, LabelSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(false);
        element_1.set_gap_jwjroq_k$(get_dp(2));
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (TextView())(element_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element_1.willAddChild_hz2iwc_k$(element_2);
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_2);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_2));
        element_2.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          return inputLabel($this$invoke);
        });
        element_2.onStartup_vrxh3i_k$();
        element_1.addChild_2qpft2_k$(element_2);
        if (required) {
          text(themed(element_1, DangerTextSemantic_getInstance()), '*');
        }
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp$ret$18 = themed(element_0, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        var this_3 = this.validate_fnk5sm_k$(tmp$ret$18, field);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (TextInput())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_3.willAddChild_hz2iwc_k$(element_3);
        element_3.bind_gesskf_k$(element_3.content_1, withStringBuffer(field));
        setup(element_3);
        element_3.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_3);
        errorText(element_0);
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        var tmp_2 = get_issues(field);
        issueText(element, tmp_2, VOID, ($this$issueText) => $this$issueText.invoke_r7m7el_k$(this_0.get_showValidation_c0zzxd_k$()));
        element.onStartup_vrxh3i_k$();
        _this__u8e3s4.addChild_2qpft2_k$(element);
      }
      emailField$default_lqqr0_k$(_this__u8e3s4, inputLabel, field, required, setup, $super) {
        required = required === VOID ? false : required;
        var tmp;
        if (setup === VOID) {
          tmp = Form$emailField$lambda;
        } else {
          tmp = setup;
        }
        setup = tmp;
        var tmp_0;
        if ($super === VOID) {
          this.emailField_ghhlxy_k$(_this__u8e3s4, inputLabel, field, required, setup);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $super.emailField_ghhlxy_k$.call(this, _this__u8e3s4, inputLabel, field, required, setup);
        }
        return tmp_0;
      }
      dateField_porm25_k$(_this__u8e3s4, inputLabel, field, required, setup) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.Form.colWithIssueText' call
        var this_0 = this;
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
        ensureOutermostElement(element);
        _this__u8e3s4.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = themed(element, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element_0, LabelSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(false);
        element_1.set_gap_jwjroq_k$(get_dp(2));
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (TextView())(element_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element_1.willAddChild_hz2iwc_k$(element_2);
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_2);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_2));
        element_2.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          return inputLabel($this$invoke);
        });
        element_2.onStartup_vrxh3i_k$();
        element_1.addChild_2qpft2_k$(element_2);
        if (required) {
          text(themed(element_1, DangerTextSemantic_getInstance()), '*');
        }
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp$ret$18 = themed(element_0, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
        var this_3 = this.validate_fnk5sm_k$(tmp$ret$18, field);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (LocalDateField())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_3.willAddChild_hz2iwc_k$(element_3);
        element_3.bind_gesskf_k$(element_3.content_1, field);
        setup(element_3);
        element_3.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_3);
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        var tmp_2 = get_issues(field);
        issueText(element, tmp_2, VOID, ($this$issueText) => $this$issueText.invoke_r7m7el_k$(this_0.get_showValidation_c0zzxd_k$()));
        element.onStartup_vrxh3i_k$();
        _this__u8e3s4.addChild_2qpft2_k$(element);
      }
      dateField$default_ksnshl_k$(_this__u8e3s4, inputLabel, field, required, setup, $super) {
        required = required === VOID ? false : required;
        var tmp;
        if (setup === VOID) {
          tmp = Form$dateField$lambda;
        } else {
          tmp = setup;
        }
        setup = tmp;
        var tmp_0;
        if ($super === VOID) {
          this.dateField_porm25_k$(_this__u8e3s4, inputLabel, field, required, setup);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $super.dateField_porm25_k$.call(this, _this__u8e3s4, inputLabel, field, required, setup);
        }
        return tmp_0;
      }
      selectField_qav2qe_k$(_this__u8e3s4, inputLabel, field, options, required, render) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.Form.colWithIssueText' call
        var this_0 = this;
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
        ensureOutermostElement(element);
        _this__u8e3s4.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = themed(element, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element_0, LabelSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(false);
        element_1.set_gap_jwjroq_k$(get_dp(2));
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (TextView())(element_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element_1.willAddChild_hz2iwc_k$(element_2);
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_2);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_2));
        element_2.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          return inputLabel($this$invoke);
        });
        element_2.onStartup_vrxh3i_k$();
        element_1.addChild_2qpft2_k$(element_2);
        if (required) {
          text(themed(element_1, DangerTextSemantic_getInstance()), '*');
        }
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_3 = themed(element_0, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_3.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_4 = get_centered(element_3);
        var tmp$ret$23 = weight(this_4, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.select' call
        var this_5 = this.validate_fnk5sm_k$(tmp$ret$23, field);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Select())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_5.willAddChild_hz2iwc_k$(element_4);
        element_4.bind_64a41i_k$(field, options, render);
        element_4.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_4);
        element_3.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_3);
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        var tmp_2 = get_issues(field);
        issueText(element, tmp_2, VOID, ($this$issueText) => $this$issueText.invoke_r7m7el_k$(this_0.get_showValidation_c0zzxd_k$()));
        element.onStartup_vrxh3i_k$();
        _this__u8e3s4.addChild_2qpft2_k$(element);
      }
      priceInput_scza56_k$(_this__u8e3s4, inputLabel, field, required, setup) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.Form.colWithIssueText' call
        var this_0 = this;
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
        ensureOutermostElement(element);
        _this__u8e3s4.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = themed(element, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element_0, LabelSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(false);
        element_1.set_gap_jwjroq_k$(get_dp(2));
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (TextView())(element_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element_1.willAddChild_hz2iwc_k$(element_2);
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_2);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_2));
        element_2.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          return inputLabel($this$invoke);
        });
        element_2.onStartup_vrxh3i_k$();
        element_1.addChild_2qpft2_k$(element_2);
        if (required) {
          text(themed(element_1, DangerTextSemantic_getInstance()), '*');
        }
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp$ret$18 = themed(element_0, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_3 = get_unpadded(tmp$ret$18);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_3.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
        var this_4 = get_centered(element_3);
        var tmp$ret$23 = themed(this_4, ForcePaddingSemantic_getInstance());
        text(tmp$ret$23, '$');
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
        var this_5 = weight(element_3, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
        var this_6 = themed(this_5, ForcePaddingSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (NumberInput())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_6.willAddChild_hz2iwc_k$(element_4);
        element_4.set_align_ypalx0_k$(Align_End_getInstance());
        var tmp_2 = Form$priceInput$lambda_0;
        element_4.bind_gesskf_k$(element_4.content_1, field.lens_drj4fu_k$(tmp_2, Form$priceInput$lambda_1));
        setup(element_4);
        element_4.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_4);
        element_3.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_3);
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        var tmp_3 = get_issues(field);
        issueText(element, tmp_3, VOID, ($this$issueText) => $this$issueText.invoke_r7m7el_k$(this_0.get_showValidation_c0zzxd_k$()));
        element.onStartup_vrxh3i_k$();
        _this__u8e3s4.addChild_2qpft2_k$(element);
      }
      priceInput$default_xy5xas_k$(_this__u8e3s4, inputLabel, field, required, setup, $super) {
        required = required === VOID ? false : required;
        var tmp;
        if (setup === VOID) {
          tmp = Form$priceInput$lambda;
        } else {
          tmp = setup;
        }
        setup = tmp;
        var tmp_0;
        if ($super === VOID) {
          this.priceInput_scza56_k$(_this__u8e3s4, inputLabel, field, required, setup);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $super.priceInput_scza56_k$.call(this, _this__u8e3s4, inputLabel, field, required, setup);
        }
        return tmp_0;
      }
      formIssuesDialog_5qr5df_k$(_this__u8e3s4, header, body, confirmationText) {
        return dialog(_this__u8e3s4, VOID, ($this$dialog, close) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          h2(element, header);
          var tmp0_safe_receiver = body;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(element);
          // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Separator())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
          var this_1 = get_atEnd(element);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_2 = themed(this_1, ButtonSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_2.willAddChild_hz2iwc_k$(element_1);
          text(element_1, confirmationText);
          onClick(element_1, VOID, VOID, VOID, Form$formIssuesDialog$lambda$slambda(close));
          element_1.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        });
      }
      formIssuesDialog$default_8ey6bo_k$(_this__u8e3s4, header, body, confirmationText, $super) {
        header = header === VOID ? 'Missing information' : header;
        var tmp;
        if (body === VOID) {
          tmp = Form$formIssuesDialog$lambda;
        } else {
          tmp = body;
        }
        body = tmp;
        confirmationText = confirmationText === VOID ? 'Okay' : confirmationText;
        var tmp_0;
        if ($super === VOID) {
          this.formIssuesDialog_5qr5df_k$(_this__u8e3s4, header, body, confirmationText);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $super.formIssuesDialog_5qr5df_k$.call(this, _this__u8e3s4, header, body, confirmationText);
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'Form', Form);
    FormClass = $;
  }
  return FormClass;
}
//region block: exports
export {
  Form as Formjae7dnqjclc3,
};
//endregion

//# sourceMappingURL=form.mjs.map
